import React from "react";

// Vegetable data extracted from your content
const vegetables = [
  {
    name: "Green Chilli",
    description: "Green Chilly - G4, Year round supply.",
    pack: "5KG & 7Kg & CP",
    image: "https://tse4.mm.bing.net/th/id/OIP.JlEt5e5zAnCcuCZzVVQq-QHaEH?rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Okra",
    description: "Okra or Bhindi comes with various sizes 5cm to 7cm.",
    pack: "5KG & 7Kg & CP",
    image: "https://tse2.mm.bing.net/th/id/OIP.SiPpWO_LSOyNlF1cadt5sgHaEo?rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Brinjal",
    description: "Brinjal or Eggplant is widely used vegetable used for many Indian cuisine.",
    pack: "5KG & 7Kg & CP",
    image: "https://tse3.mm.bing.net/th/id/OIP.lDsWTi07DrGwIAxUlxef9AHaE8?w=600&h=400&rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Bitter Gourd",
    description: "Bitter Gourd or Karela comes in two sizes Baby and Normal.",
    pack: "5Kg & 7Kg & 10Kg",
    image: "https://th.bing.com/th/id/R.fbc6212e9bf986c2c5984b47e04672e2?rik=o3ggIfj8HZUgsg&riu=http%3a%2f%2fwww.foodofy.com%2fwp-content%2fuploads%2f2015%2f06%2fbitter-gourd-2.jpg&ehk=EOoowef4XaSMpGzbKP4xV%2fDnT218agOdpMadoLBXv50%3d&risl=&pid=ImgRaw&r=0",
  },
  {
    name: "Ivy Gourd",
    description: "Ivy Gourd or Tendaly is rich green vegetable, which is high in fibre and iron.",
    pack: "5Kg & 7Kg & CP",
    image: "https://www.womenfitness.net/img2015/artimg/june/Coccinia-grandis1.jpg",
  },
  {
    name: "Beetroot",
    description: "Beetroot is part of many salad plates as well as juices.",
    pack: "5Kg & 7Kg & 10Kg",
    image: "https://tse4.mm.bing.net/th/id/OIP.cTc4rlcr5johJf4YvkR5rQHaE8?rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Amla",
    description: "Amla or Gooseberry is rich in Vitamin C and used in many Indian cuisine.",
    pack: "5Kg & 7Kg",
    image: "https://www.healthbenefitstimes.com/9/gallery/amla/Amla.jpg",
  },
  {
    name: "French Beans",
    description: "French Beans comes with various sizes 5cm to 7cm.",
    pack: "5KG & 7Kg & CP",
    image: "https://i.zoomtventertainment.com/story/Health_benefits_of_French_Beans.jpg",
  },
  {
    name: "Bottle Gourd",
    description: "Lauki or Doodhi, is light vegetable, curated for all season.",
    pack: "5KG & 7Kg & CP",
    image: "https://tse2.mm.bing.net/th/id/OIP.cmYT7C2ai-3i3VjH5VfREwHaFj?w=1280&h=960&rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Green Mango",
    description: "Raw green mangoes, perfect for pickles, chutneys, and summer drinks.",
    pack: "5Kg & 7Kg & 10Kg",
    image: "https://tse1.mm.bing.net/th/id/OIP.cE_HMOt0eTJ2u3FCDWvp5AHaH9?rs=1&pid=ImgDetMain&o=7&rm=3",
  },
  {
    name: "Cluster Beans",
    description: "Cluster Beans or Guar, is known for moderative blood sugar level.",
    pack: "5Kg & 7Kg & CP",
    image: "https://mildlyindian.com/wp-content/uploads/2023/01/cluster-beans-1024x683.jpg",
  },
  {
    name: "Spinach",
    description: "Spinach is packed with high iron levels and comes year round.",
    pack: "3Kg",
    image: "https://www.thepaleomom.com/wp-content/uploads/2016/06/spinach.jpg",
  },
  {
    name: "Sapota",
    description: "Sapota or Chikoo is sweet fruit with high fibre and vitamin content.",
    pack: "3Kg & 5Kg",
    image: "https://magicfarms.in/wp-content/uploads/2021/09/2323b8cf-55e1-433f-914d-cc6a18fb0922.jpeg",
  },
  {
    name: "Pomegranate",
    description: "Pomegranate or Anar is high in antioxidant and good for heart health.",
    pack: "3kg-5Kg-7Kg",
    image: "https://www.health.com/thmb/B-e3r9wme2bVLalt0Kq_mUPBhN8=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Pomegranate-fc75404736b446c5aa26194e1d2b1d0a.jpg",
  },
  {
    name: "Mangoes",
    description: "King of Fruits - Variety: Alphonso, Kesar, Langra, Chausa, Deshari, etc.",
    pack: "3Kg-5Kg-7Kg",
    image: "https://th.bing.com/th?q=Bunch+of+Mangoes&w=120&h=120&c=1&rs=1&qlt=70&o=7&cb=1&pid=InlineBlock&rm=3&mkt=en-IN&cc=IN&setlang=en&adlt=moderate&t=1&mw=247",
  },
   {
    name: "Miscellaneous",
    description: "Other Vegetables such as French Beans, Methi, etc.",
    pack: "3kg-5Kg-7Kg",
    image: "https://thumbs.dreamstime.com/z/vegetable-10953878.jpg",
  },
];

const VegetableCatalog = () => {
  return (
    <section className="bg-green-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-green-800 mb-4">Our Premium Produce</h2>
          <p className="text-xl text-green-700 max-w-3xl mx-auto">
            Fresh, high‑quality vegetables sourced directly from farms – available in convenient pack sizes.
          </p>
        </div>

        {/* Vegetable Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {vegetables.map((veg, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition transform hover:-translate-y-1 duration-300"
            >
              {/* Image */}
              <div className="h-40 bg-green-100 flex items-center justify-center overflow-hidden">
                <img
                  src={veg.image}
                  alt={veg.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/300x200?text=Vegetable";
                  }}
                />
              </div>
              {/* Content */}
              <div className="p-5">
                <h3 className="text-xl font-bold text-green-700 mb-2">{veg.name}</h3>
                <p className="text-gray-600 text-sm mb-3">{veg.description}</p>
                <div className="flex items-center justify-between">
                  <span className="inline-block bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-1 rounded">
                    {veg.pack}
                  </span>
                  <span className="text-green-600 text-sm font-medium">Fresh</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VegetableCatalog;